<template>
  <div class="forgot-password">
    <h3>忘记密码</h3>
    <form @submit.prevent="handleSubmit">
      <div class="form-content">
        <div class="input-group">
          <label for="username">请输入你注册时的用户名:</label>
          <input v-model="username" id="username" type="text" required/>
        </div>
        
        <div class="input-group">
          <label for="useremail">请输入你注册时的邮箱名:</label>
          <input v-model="useremail" id="useremail" type="email" required/>
        </div>

        <div class="input-group">
          <label>验证码：</label>
          <div class="code-wrapper">
            <el-input v-model="code" placeholder="请输入验证码" style="flex: 1;" />
            <el-button 
              @click="sendCode" 
              :disabled="isSending"
              style="width: 120px; margin-left: 10px;">
              {{ buttonText }}
            </el-button>
          </div>
        </div>
      </div>
      
      <div class="submit-button">
        <button type="submit">提交</button>
      </div>
    </form>
  </div>
</template>

<script setup>
import { ref, reactive } from 'vue';
import axios from 'axios';
import { ElMessage } from 'element-plus';

const username = ref('');
const useremail = ref('');
const code = ref('');
const isSending = ref(false);
const countdown = ref(0);
const buttonText = ref('发送验证码');

// 发送验证码函数
const sendCode = async () => {
  if (!username.value.trim() || !useremail.value.trim()) {
    ElMessage.warning('请输入用户名和邮箱');
    return;
  }

  if (isSending.value) return;

  isSending.value = true;
  
  try {
    // 这里使用GET请求发送验证码，参数通过params传递
    const response = await axios.get('/api/sendMail', {
      params: {
        email: useremail.value,
      }
    });
    
    if (response.data.code === '200') {
      ElMessage.success('验证码已发送');
      startCountdown();
    } else {
      ElMessage.error(response.data.msg || '发送失败');
      isSending.value = false;
    }
  } catch (error) {
    console.error('发送验证码失败:', error);
    ElMessage.error('发送失败，请重试');
    isSending.value = false;
  }
};

// 倒计时函数
const startCountdown = () => {
  countdown.value = 60;
  const timer = setInterval(() => {
    countdown.value--;
    if (countdown.value <= 0) {
      clearInterval(timer);
      isSending.value = false;
      buttonText.value = '发送验证码';
    } else {
      buttonText.value = `${countdown.value}秒后重发`;
    }
  }, 1000);
};

const handleSubmit = async () => {
  if (!code.value.trim()) {
    ElMessage.warning('请输入验证码');
    return;
  }

  try {
    const response = await axios.post(`/api/getPwdByName?username=${username.value}`+'&code='+code.value);
    console.log('Response:', response);
    if (response.data.code === '200') {
      alert(`你的密码是: ${response.data.data}`);
    } else {
      alert(response.data.msg);
    }
  } catch (error) {
    console.error('Error:', error);
    alert('请求出错，请检查控制台了解详细信息');
  }
};
</script>

<style scoped>
.forgot-password {
  background-color: #fff;
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  max-width: 500px;
  margin: 50px auto;
}

.forgot-password h3 {
  margin-bottom: 25px;
  font-size: 1.8em;
  text-align: center;
  color: #2c3e50;
  font-weight: 600;
}

.form-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.input-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.input-group label {
  font-weight: 500;
  color: #606266;
  font-size: 14px;
}

.input-group input {
  width: 100%;
  padding: 12px;
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  transition: border-color 0.3s ease;
}

.input-group input:focus {
  border-color: #409eff;
  outline: none;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
}

.code-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
}

:deep(.code-wrapper .el-input .el-input__wrapper) {
  border-radius: 6px;
}

:deep(.code-wrapper .el-button) {
  border-radius: 6px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  color: white;
  transition: all 0.3s ease;
}

:deep(.code-wrapper .el-button:hover:not(:disabled)) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

:deep(.code-wrapper .el-button:disabled) {
  background: #c0c4cc;
  cursor: not-allowed;
}

.submit-button {
  margin-top: 25px;
  text-align: center;
}

.submit-button button {
  padding: 12px 30px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 1em;
  font-weight: 500;
  color: white;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  transition: all 0.3s ease;
}

.submit-button button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
}

@media (max-width: 768px) {
  .forgot-password {
    margin: 20px;
    padding: 20px;
  }
  
  .code-wrapper {
    flex-direction: column;
    align-items: stretch;
  }
  
  :deep(.code-wrapper .el-button) {
    width: 100%;
    margin-left: 0;
    margin-top: 10px;
  }
}
</style>